import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import DownloadIcon from '../../icon/download.svg'

const Action = ({ specialization, /* integrationSettings, */ ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'flex',
      'flex-row',
      'items-center',
      'justify-center',
      'py-3',
      'px-3',
      'cursor-pointer'
    ]
  )

  attrs.style = {
    ...(attrs.style || {}),
    outline: 'none',
    border: 'hidden',
    borderRadius: '0 1.5rem 1.5rem 1.5rem',
    minHeight: '3rem'
  }
  attrs.href = get(specialization, 'attachment.meta.downloadUrl', null)
  attrs.target = '_blank'

  return <a
    {...attrs}>
    Descarga el contenido
    <DownloadIcon
      width={24}
      height={24}
      className={'ml-2'} />
  </a>
}

Action.propTypes = {
  specialization: PropTypes.object
  /* integrationSettings: PropTypes.object */
}

export default React.memo(Action)
